import withMouseScrollHOC from "@common/hocs/withMouseScroll";
import loadable from "@loadable/component";
import React from "react";
import { Basicprimitives } from "../types";

const OrganizationalDiagramBase = loadable<Props<any>, any>(
  () => import(/* webpackChunkName: "basicprimitivesreact" */ "basicprimitivesreact"),
  {
    resolveComponent: (cmp) => withMouseScrollHOC<Props<any>>(cmp.OrgDiagram, (x) => x.scrollPanelRef?.current)
  }
);

type Props<T extends Basicprimitives.OrgItemConfig> = {
  config: Basicprimitives.OrgDiagramConfig<T>;
};
const OrganizationalDiagram = <T extends Basicprimitives.OrgItemConfig>(props: Props<T>) => {
  const Diagram = OrganizationalDiagramBase as React.ComponentClass<Basicprimitives.OrgDiagramProps<T>>;

  const onCursorChanging = React.useCallback((event, data: { context: Basicprimitives.OrgItemConfig }) => {
    const { context } = data;
    if (!context) return false;

    // Return true in order to suppress set highlight item change in control
    // it will be updated via subsequent state change of application
    return context.noHighlight ?? false;
  }, []);

  const onHighlightChanging = React.useCallback((event, data: { context: Basicprimitives.OrgItemConfig }) => {
    const { context } = data;
    if (!context) return false;

    // Return true in order to suppress set highlight item change in control
    // it will be updated via subsequent state change of application
    return context.noHighlight ?? false;
  }, []);

  return (
    <Diagram
      centerOnCursor
      config={props.config}
      onCursorChanging={onCursorChanging}
      onHighlightChanging={onHighlightChanging}
    />
  );
};

export default OrganizationalDiagram;

export const preloadDiagrams = () => OrganizationalDiagramBase.preload();
